// extracted by mini-css-extract-plugin
module.exports = {"ClassTest":"ClassTest_ClassTest__1klDl","Template":"ClassTest_Template__1gxS7"};